import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/common/GlobalFooter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/common/ScrollManager.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/common/WhatsAppButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CartProvider"] */ "/vercel/path0/src/lib/cart/CartContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SiteContentProvider"] */ "/vercel/path0/src/lib/content/SiteContentContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CurrencyProvider"] */ "/vercel/path0/src/lib/currency/CurrencyContext.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/index.css");
